export default "__VITE_PUBLIC_ASSET__b83379db__"